const ProductVariants = {
  "dev.cocoandeve.com": [
    {
      "id": 4543113592867,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-set",
      "sku": "CE0000072040"
    },
    {
      "id": 4543113592867,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-set",
      "sku": "CE0000072020"
    },
    {
      "id": 4543113265187,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000036020"
    },
    {
      "id": 4543113265187,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000036040"
    },
    {
      "id": 4543113265187,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000036060"
    },
    {
      "id": 4543113265187,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000072020"
    },
    {
      "id": 4543113265187,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000072040"
    },
    {
      "id": 4543113265187,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000072060"
    },
    {
      "id": 4630922559523,
      "product_handle": "bronzing-self-tanner-drops",
      "sku": "CE0000432040"
    },
    {
      "id": 4630922559523,
      "product_handle": "bronzing-self-tanner-drops",
      "sku": "CE0000432030"
    },
    {
      "id": 4803978723363,
      "product_handle": "glow-essentials-bundle",
      "sku": "CE0001202020"
    },
    {
      "id": 4803978723363,
      "product_handle": "glow-essentials-bundle",
      "sku": "CE0001202040"
    },
    {
      "id": 4803978723363,
      "product_handle": "glow-essentials-bundle",
      "sku": "CE0001202060"
    },
    {
      "id": 4803978723363,
      "product_handle": "glow-essentials-bundle",
      "sku": "CE0002152020"
    },
    {
      "id": 4803978723363,
      "product_handle": "glow-essentials-bundle",
      "sku": "CE0001962020"
    },
    {
      "id": 4803978723363,
      "product_handle": "glow-essentials-bundle",
      "sku": "CE0002162020"
    },
    {
      "id": 6741826994211,
      "product_handle": "antioxidant-face-tanning-micromist",
      "sku": "CE0001512020"
    },
    {
      "id": 6778958676003,
      "product_handle": "tan-masters-kit",
      "sku": "CE0003532020"
    }
  ],
  "au.cocoandeve.com": [
    {
      "id": 2251503566902,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-set",
      "sku": "CE0000072040"
    },
    {
      "id": 2251503566902,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-set",
      "sku": "CE0000072020"
    },
    {
      "id": 2251503271990,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000036020"
    },
    {
      "id": 2251503271990,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000036040"
    },
    {
      "id": 2251503271990,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000036060"
    },
    {
      "id": 2251503271990,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000072020"
    },
    {
      "id": 2251503271990,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000072040"
    },
    {
      "id": 2251503271990,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000072060"
    },
    {
      "id": 4735725568054,
      "product_handle": "bronzing-self-tanner-drops",
      "sku": "CE0000432040"
    },
    {
      "id": 4735725568054,
      "product_handle": "bronzing-self-tanner-drops",
      "sku": "CE0000432030"
    },
    {
      "id": 4733448945718,
      "product_handle": "glow-essentials-bundle",
      "sku": "CE0001202020"
    },
    {
      "id": 4733448945718,
      "product_handle": "glow-essentials-bundle",
      "sku": "CE0001202040"
    },
    {
      "id": 4733448945718,
      "product_handle": "glow-essentials-bundle",
      "sku": "CE0001202060"
    },
    {
      "id": 4733448945718,
      "product_handle": "glow-essentials-bundle",
      "sku": "CE0002152020"
    },
    {
      "id": 4733448945718,
      "product_handle": "glow-essentials-bundle",
      "sku": "CE0001962020"
    },
    {
      "id": 4733448945718,
      "product_handle": "glow-essentials-bundle",
      "sku": "CE0002162020"
    },
    {
      "id": 6892921880630,
      "product_handle": "antioxidant-face-tanning-micromist",
      "sku": "CE0001512020"
    },
    {
      "id": 6915856072758,
      "product_handle": "tan-masters-kit",
      "sku": "CE0003532020"
    }
  ],
  "ca.cocoandeve.com": [
    {
      "id": 3765691187253,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-set",
      "sku": "CE0000072040"
    },
    {
      "id": 3765691187253,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-set",
      "sku": "CE0000072020"
    },
    {
      "id": 3764533723189,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000036020"
    },
    {
      "id": 3764533723189,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000036040"
    },
    {
      "id": 3764533723189,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000036060"
    },
    {
      "id": 3764533723189,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000072020"
    },
    {
      "id": 3764533723189,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000072040"
    },
    {
      "id": 3764533723189,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000072060"
    },
    {
      "id": 4668753444917,
      "product_handle": "bronzing-self-tanner-drops",
      "sku": "CE0000432040"
    },
    {
      "id": 4668753444917,
      "product_handle": "bronzing-self-tanner-drops",
      "sku": "CE0000432030"
    },
    {
      "id": 4849909563445,
      "product_handle": "glow-essentials-bundle",
      "sku": "CE0001202020"
    },
    {
      "id": 4849909563445,
      "product_handle": "glow-essentials-bundle",
      "sku": "CE0001962020"
    },
    {
      "id": 7102154899509,
      "product_handle": "antioxidant-face-tanning-micromist",
      "sku": "CE0001512020"
    },
    {
      "id": 7144782626869,
      "product_handle": "tan-masters-kit",
      "sku": "CE0003532020"
    }
  ],
  "de.cocoandeve.com": [
    {
      "id": 5748176650405,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-set",
      "sku": "CE0000072040"
    },
    {
      "id": 5748176650405,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-set",
      "sku": "CE0000072020"
    },
    {
      "id": 5748176486565,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000032020"
    },
    {
      "id": 5748176486565,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000036040"
    },
    {
      "id": 5748176486565,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000036060"
    },
    {
      "id": 5748176486565,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000072020"
    },
    {
      "id": 5748176486565,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000072040"
    },
    {
      "id": 5748176486565,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000072060"
    },
    {
      "id": 5748174848165,
      "product_handle": "bronzing-self-tanner-drops",
      "sku": "CE0000432040"
    },
    {
      "id": 5748174848165,
      "product_handle": "bronzing-self-tanner-drops",
      "sku": "CE0000432030"
    },
    {
      "id": 5748175044773,
      "product_handle": "glow-essentials-bundle",
      "sku": "CE0001202020"
    },
    {
      "id": 5748175044773,
      "product_handle": "glow-essentials-bundle",
      "sku": "CE0001962020"
    },
    {
      "id": 8110017544357,
      "product_handle": "antioxidant-face-tanning-micromist",
      "sku": "CE0001512020"
    },
    {
      "id": 8146858508453,
      "product_handle": "tan-masters-kit",
      "sku": "CE0003532020"
    }
  ],
  "eu.cocoandeve.com": [
    {
      "id": 3686774374484,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-set",
      "sku": "CE0000072040"
    },
    {
      "id": 3686774374484,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-set",
      "sku": "CE0000072020"
    },
    {
      "id": 3686774145108,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000032020"
    },
    {
      "id": 3686774145108,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000036040"
    },
    {
      "id": 3686774145108,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000036060"
    },
    {
      "id": 3686774145108,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000072020"
    },
    {
      "id": 3686774145108,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000072040"
    },
    {
      "id": 3686774145108,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000072060"
    },
    {
      "id": 4735345885268,
      "product_handle": "bronzing-self-tanner-drops",
      "sku": "CE0000432040"
    },
    {
      "id": 4735345885268,
      "product_handle": "bronzing-self-tanner-drops",
      "sku": "CE0000432030"
    },
    {
      "id": 4758303080532,
      "product_handle": "glow-essentials-bundle",
      "sku": "CE0001202020"
    },
    {
      "id": 4758303080532,
      "product_handle": "glow-essentials-bundle",
      "sku": "CE0001962020"
    },
    {
      "id": 7708293365958,
      "product_handle": "antioxidant-face-tanning-micromist",
      "sku": "CE0001512020"
    },
    {
      "id": 7756544835782,
      "product_handle": "tan-masters-kit",
      "sku": "CE0003532020"
    }
  ],
  "fr.cocoandeve.com": [
    {
      "id": 6858547167416,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-set",
      "sku": "CE0000072040"
    },
    {
      "id": 6858547167416,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-set",
      "sku": "CE0000072020"
    },
    {
      "id": 6858547069112,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000032020"
    },
    {
      "id": 6858547069112,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000036040"
    },
    {
      "id": 6858547069112,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000036060"
    },
    {
      "id": 6858547069112,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000072020"
    },
    {
      "id": 6858547069112,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000072040"
    },
    {
      "id": 6858547069112,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000072060"
    },
    {
      "id": 6795584241848,
      "product_handle": "bronzing-self-tanner-drops",
      "sku": "CE0000432040"
    },
    {
      "id": 6795584241848,
      "product_handle": "bronzing-self-tanner-drops",
      "sku": "CE0000432030"
    },
    {
      "id": 6795583717560,
      "product_handle": "glow-essentials-bundle",
      "sku": "CE0001202020"
    },
    {
      "id": 6795583717560,
      "product_handle": "glow-essentials-bundle",
      "sku": "CE0001962020"
    },
    {
      "id": 7240691515576,
      "product_handle": "antioxidant-face-tanning-micromist",
      "sku": "CE0001512020"
    },
    {
      "id": 7263843123384,
      "product_handle": "tan-masters-kit",
      "sku": "CE0003532020"
    }
  ],
  "int.cocoandeve.com": [
    {
      "id": 3963752939629,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-set",
      "sku": "CE0000072040"
    },
    {
      "id": 3963752939629,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-set",
      "sku": "CE0000072020"
    },
    {
      "id": 3963752546413,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000036020"
    },
    {
      "id": 3963752546413,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000036040"
    },
    {
      "id": 3963752546413,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000032060"
    },
    {
      "id": 3963752546413,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000072020"
    },
    {
      "id": 3963752546413,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000072040"
    },
    {
      "id": 3963752546413,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000072060"
    },
    {
      "id": 4814015529069,
      "product_handle": "bronzing-self-tanner-drops",
      "sku": "CE0000432040"
    },
    {
      "id": 4814015529069,
      "product_handle": "bronzing-self-tanner-drops",
      "sku": "CE0000432030"
    },
    {
      "id": 4812090867821,
      "product_handle": "glow-essentials-bundle",
      "sku": "CE0001202020"
    },
    {
      "id": 4812090867821,
      "product_handle": "glow-essentials-bundle",
      "sku": "CE0001962020"
    },
    {
      "id": 6937480396909,
      "product_handle": "antioxidant-face-tanning-micromist",
      "sku": "CE0001512020"
    },
    {
      "id": 6974503616621,
      "product_handle": "tan-masters-kit",
      "sku": "CE0003532020"
    }
  ],
  "uk.cocoandeve.com": [
    {
      "id": 3680558776397,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-set",
      "sku": "CE0000072040"
    },
    {
      "id": 3680558776397,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-set",
      "sku": "CE0000072020"
    },
    {
      "id": 3680558415949,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000036020"
    },
    {
      "id": 3680558415949,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000036040"
    },
    {
      "id": 3680558415949,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000036060"
    },
    {
      "id": 3680558415949,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000072020"
    },
    {
      "id": 3680558415949,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000072040"
    },
    {
      "id": 3680558415949,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000072060"
    },
    {
      "id": 4834082979917,
      "product_handle": "bronzing-self-tanner-drops",
      "sku": "CE0000432040"
    },
    {
      "id": 4834082979917,
      "product_handle": "bronzing-self-tanner-drops",
      "sku": "CE0000432030"
    },
    {
      "id": 4831011864653,
      "product_handle": "glow-essentials-bundle",
      "sku": "CE0001202020"
    },
    {
      "id": 4831011864653,
      "product_handle": "glow-essentials-bundle",
      "sku": "CE0001962020"
    },
    {
      "id": 6827730534477,
      "product_handle": "antioxidant-face-tanning-micromist",
      "sku": "CE0001512020"
    },
    {
      "id": 6846803312717,
      "product_handle": "tan-masters-kit",
      "sku": "CE0003532020"
    }
  ],
  "us.cocoandeve.com": [
    {
      "id": 4024566186048,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-set",
      "sku": "CE0000072040"
    },
    {
      "id": 4024566186048,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-set",
      "sku": "CE0000072020"
    },
    {
      "id": 4024565301312,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000036020"
    },
    {
      "id": 4024565301312,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000036040"
    },
    {
      "id": 4024565301312,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000036060"
    },
    {
      "id": 4024565301312,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000072020"
    },
    {
      "id": 4024565301312,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000072040"
    },
    {
      "id": 4024565301312,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000072060"
    },
    {
      "id": 4803172827200,
      "product_handle": "bronzing-self-tanner-drops",
      "sku": "CE0000432040"
    },
    {
      "id": 4803172827200,
      "product_handle": "bronzing-self-tanner-drops",
      "sku": "CE0000432030"
    },
    {
      "id": 4802587492416,
      "product_handle": "glow-essentials-bundle",
      "sku": "CE0001202020"
    },
    {
      "id": 4802587492416,
      "product_handle": "glow-essentials-bundle",
      "sku": "CE0001962020"
    },
    {
      "id": 6684863397952,
      "product_handle": "antioxidant-face-tanning-micromist",
      "sku": "CE0001512020"
    },
    {
      "id": 6704402530368,
      "product_handle": "tan-masters-kit",
      "sku": "CE0003532020"
    }
  ],
  "www.cocoandeve.com": [
    {
      "id": 4024566186048,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-set",
      "sku": "CE0000072040"
    },
    {
      "id": 4024566186048,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-set",
      "sku": "CE0000072020"
    },
    {
      "id": 4024565301312,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000036020"
    },
    {
      "id": 4024565301312,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000036040"
    },
    {
      "id": 4024565301312,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000036060"
    },
    {
      "id": 4024565301312,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000072020"
    },
    {
      "id": 4024565301312,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000072040"
    },
    {
      "id": 4024565301312,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000072060"
    },
    {
      "id": 4803172827200,
      "product_handle": "bronzing-self-tanner-drops",
      "sku": "CE0000432040"
    },
    {
      "id": 4803172827200,
      "product_handle": "bronzing-self-tanner-drops",
      "sku": "CE0000432030"
    },
    {
      "id": 4802587492416,
      "product_handle": "glow-essentials-bundle",
      "sku": "CE0001202020"
    },
    {
      "id": 4802587492416,
      "product_handle": "glow-essentials-bundle",
      "sku": "CE0001962020"
    },
    {
      "id": 6684863397952,
      "product_handle": "antioxidant-face-tanning-micromist",
      "sku": "CE0001512020"
    },
    {
      "id": 6704402530368,
      "product_handle": "tan-masters-kit",
      "sku": "CE0003532020"
    }
  ],
  "my.cocoandeve.com": [
    {
      "id": 6708373127241,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-set",
      "sku": "CE0000072040"
    },
    {
      "id": 6708373127241,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-set",
      "sku": "CE0000072020"
    },
    {
      "id": 6708372963401,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000036020"
    },
    {
      "id": 6708372963401,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000032040"
    },
    {
      "id": 6708372963401,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000032060"
    },
    {
      "id": 6708372963401,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000072020"
    },
    {
      "id": 6708372963401,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000072040"
    },
    {
      "id": 6708372963401,
      "product_handle": "sunny-honey-bali-bronzing-self-tan-mousse",
      "sku": "CE0000072060"
    },
    {
      "id": 6708374765641,
      "product_handle": "bronzing-self-tanner-drops",
      "sku": "CE0000432040"
    },
    {
      "id": 6708374765641,
      "product_handle": "bronzing-self-tanner-drops",
      "sku": "CE0000432030"
    },
    {
      "id": 6708371652681,
      "product_handle": "glow-essentials-bundle",
      "sku": "CE0001202020"
    },
    {
      "id": 6708371652681,
      "product_handle": "glow-essentials-bundle",
      "sku": "CE0001962020"
    },
    {
      "id": 6878546067529,
      "product_handle": "antioxidant-face-tanning-micromist",
      "sku": "CE0001512020"
    },
    {
      "id": 6891143790665,
      "product_handle": "tan-masters-kit",
      "sku": "CE0003532020"
    }
  ]
};

export default ProductVariants;
